import { useFormik } from 'formik';
import { FormGroup } from 'shared-components';
import * as Yup from 'yup';
import styles from './reset.module.css';
import { Button } from 'shared-components';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Routes from '../../app/routes';
import { ErrorText } from 'shared-components';
import { useResetLoginMutation } from './forgotten.api';
import { Card } from 'shared-components';

const ResetSchema = Yup.object().shape({
  password: Yup.string().required('Required'),
  duplicatePassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Please confirm your password'),
});

export const ResetPassword = () => {
  const { token } = useParams<{ token: string }>();
  const [reset] = useResetLoginMutation();
  const nav = useNavigate();
  const { getFieldProps, isSubmitting, touched, errors, handleSubmit } =
    useFormik({
      initialValues: {
        password: '',
        duplicatePassword: '',
      },
      enableReinitialize: true,
      validationSchema: ResetSchema,
      onSubmit: async (values, { setSubmitting }) => {
        const result = await reset({ ...values, token: token ?? '' });
        if ('error' in result) {
          console.error(result.error);
        } else if ('data' in result) {
          nav('/');
        }
        setSubmitting(false);
      },
    });

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <h1 className={styles.title}>Set a new password</h1>
        <form className={styles.form} onSubmit={handleSubmit}>
          <FormGroup className={styles.password}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              {...getFieldProps('password')}
            />
            {touched.password && errors.password ? (
              <ErrorText>{errors.password}</ErrorText>
            ) : null}
          </FormGroup>
          <FormGroup className={styles.password}>
            <label htmlFor="duplicatePassword">Confirm password</label>
            <input
              type="password"
              id="duplicatePassword"
              {...getFieldProps('duplicatePassword')}
            />
            {touched.duplicatePassword && errors.duplicatePassword ? (
              <ErrorText>{errors.duplicatePassword}</ErrorText>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Button type="submit" disabled={isSubmitting}>
              Reset
            </Button>
          </FormGroup>
          <FormGroup>
            <Link to={Routes.LOGIN.link}>
              Remembered your password? Login now
            </Link>
          </FormGroup>
        </form>
      </Card>
    </div>
  );
};
